(function () {
  'use strict';

  // ────────────────────────────────────────────────────────────────
  // hiba-quiz-result.js — drives the v3 result page (Money + Love).
  //
  // Reads ?score=N from URL, computes band, reveals one band block,
  // counts the hero number from 0 → score over 5s (heavy ease-out),
  // and swaps the CTA copy to match the band's register.
  //
  // Respects prefers-reduced-motion: snaps to final value, no animation.
  // ────────────────────────────────────────────────────────────────

  var main = document.querySelector('.qr');
  if (!main) return;

  var lens = main.dataset.lens || 'money';

  // ── Read & validate score ───────────────────────────────────────
  // Distinguish "no score param" (bare URL visit, share, scrape) from
  // "score=0" (legitimate low scorer). A bare URL is sent back to the
  // quiz so we never render a fake-looking 0% verdict to a user who
  // didn't actually take the quiz.
  var params = new URLSearchParams(window.location.search);
  if (!params.has('score')) {
    window.location.replace('/pages/quiz-' + lens);
    return;
  }
  var rawScore = parseInt(params.get('score'), 10);
  if (isNaN(rawScore)) {
    // Score param present but not a number — treat as bad input, send to quiz.
    window.location.replace('/pages/quiz-' + lens);
    return;
  }
  rawScore = Math.max(0, Math.min(100, rawScore));

  // ── Map percentage → band ───────────────────────────────────────
  // Mirrors the JS logic in hiba-quiz.js. Percentage thresholds derived
  // from raw-score thresholds (0–9 / 10–21 / 22–34 / 35–45 over max 45).
  function bandForPercentage(p) {
    if (p <= 20) return 'quiet';
    if (p <= 47) return 'present';
    if (p <= 76) return 'active';
    return 'deep';
  }
  var band = bandForPercentage(rawScore);

  // ── Fire ResultViewed Meta Pixel event ──────────────────────────
  // Polls for fbq up to 5s (250ms × 20 attempts). Shopify's Customer Events
  // sandbox sometimes installs fbq AFTER this script runs — without the
  // poll, ~50% of result-page views miss the event. (Agent-verified bug.)
  (function pollAndFireResultViewed(attempt) {
    if (typeof window.fbq === 'function') {
      var rvRand = (window.crypto && window.crypto.randomUUID)
        ? window.crypto.randomUUID()
        : (Date.now() + '_' + Math.random().toString(36).slice(2, 10));
      var rvEventId = 'hiba_resultviewed_' + rvRand;
      try {
        window.fbq('trackCustom', 'ResultViewed', {
          lens: lens,
          score: rawScore,
          band: band,
          content_category: lens,
          content_name: 'quiz-result-' + lens + '-' + band
        }, { eventID: rvEventId });
      } catch (err) {
        console.warn('[hiba-quiz-result] fbq ResultViewed error', err);
      }
    } else if (attempt < 20) {
      setTimeout(function () { pollAndFireResultViewed(attempt + 1); }, 250);
    }
  })(0);

  // ── CTA copy by band (matched register) ─────────────────────────
  var CTA_COPY = {
    quiet:   'Start the work',
    present: 'Begin the recalibration',
    active:  'Begin the deprogramming',
    deep:    'Remove what was installed'
  };

  // ── Reveal the right band block ─────────────────────────────────
  var bands = main.querySelectorAll('.qr-band');
  bands.forEach(function (b) {
    if (b.dataset.band === band) {
      b.removeAttribute('hidden');
    }
  });

  // ── Swap the CTA label ──────────────────────────────────────────
  var ctaLabel = main.querySelector('.qr-offer__cta-label');
  if (ctaLabel && CTA_COPY[band]) {
    ctaLabel.textContent = CTA_COPY[band];
  }

  // ── Show cross-quiz nudge for quiet band only ───────────────────
  if (band === 'quiet') {
    var cross = main.querySelector('[data-cross-link]');
    if (cross) cross.removeAttribute('hidden');
  }

  // ── The number reveal ──────────────────────────────────────────
  var digits = main.querySelector('.qr-hero__digits');
  if (!digits) return;

  // Update the SR-only sibling with the final score so screen readers
  // announce a meaningful value once instead of every count-up tick.
  var srAnnounce = main.querySelector('.qr-hero__sr');
  if (srAnnounce) srAnnounce.textContent = String(rawScore) + ' percent obedient';

  var prefersReduced = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReduced || rawScore === 0) {
    digits.textContent = String(rawScore);
    return;
  }

  // 5-second count-up with heavy ease-out.
  // easeOutQuint puts ~70% of the visual change in the first ~40% of duration —
  // feels like a clinical reveal that "settles" into the final number.
  var DURATION = 5000;
  var startTs = null;

  function easeOutQuint(t) { return 1 - Math.pow(1 - t, 5); }

  function tick(ts) {
    if (startTs === null) startTs = ts;
    var elapsed = ts - startTs;
    var t = Math.min(elapsed / DURATION, 1);
    var current = Math.round(easeOutQuint(t) * rawScore);
    digits.textContent = String(current);
    if (t < 1) {
      requestAnimationFrame(tick);
    } else {
      digits.textContent = String(rawScore);
    }
  }

  // Kick the count-up on the next paint so the page is settled first.
  requestAnimationFrame(function () {
    requestAnimationFrame(tick);
  });

})();
